var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleStarsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0L21.3551 9.71132C21.5724 15.6527 26.2761 20.4175 32.1384 20.6347L42 21L32.1384 21.3653C26.2761 21.5825 21.5724 26.3473 21.3551 32.2887L21 42L20.6449 32.2887C20.4276 26.3473 15.7239 21.5825 9.86165 21.3653L0 21L9.86164 20.6347C15.7239 20.4175 20.4276 15.6527 20.6449 9.71133L21 0Z",
    fill: "#E7D6AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 12L53.1522 16.162C53.2453 18.7083 55.2612 20.7504 57.7736 20.8434L62 21L57.7736 21.1566C55.2612 21.2496 53.2453 23.2917 53.1522 25.838L53 30L52.8478 25.838C52.7547 23.2917 50.7388 21.2496 48.2264 21.1566L44 21L48.2264 20.8434C50.7388 20.7504 52.7547 18.7083 52.8478 16.162L53 12Z",
    fill: "#E7D6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleStarsIcon);
export default __webpack_public_path__ + "static/media/double-stars-icon.6aec89da3186ad9c55033946ef785aaf.svg";
export { ForwardRef as ReactComponent };